import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	requestSupportCardTitle: {
		id: 'fastshift.relationships-card.title.request-support',
		defaultMessage: 'Reach out to your dedicated FastShift Team',
		description: 'Title for the Request Support card',
	},
	requestSupportCardDescription: {
		id: 'fastshift.relationships-card.description.request-support',
		defaultMessage: 'Ask for guidance and assistance from a team of migration experts',
		description: 'Description for the Request Support card',
	},
	requestSupportCardButton: {
		id: 'fastshift.relationships-card.button.request-support',
		defaultMessage: 'Request Assistance',
		description: 'Button text for the Request Support card',
	},
});
